import React from "react";
import { CodeMirrorEditor } from "./CodeMirrorEditor";
import { MonacoCodeEditor } from "./MonacoEditor";
import { CodeEditorProps } from "./props/codeEditorProps";

export const CodeEditor = ({
    mode,
    value,
    onChange,
    size,
    errorLine,
    isDarkMode,
    className,
    type,
    jsSettings
}: CodeEditorProps) => type === "codeMirror" ?
    <CodeMirrorEditor
        value={value}
        mode={mode}
        onChange={onChange}
        size={size}
        errorLine={errorLine}
        isDarkMode={isDarkMode}
        className={className}
    /> :
    <MonacoCodeEditor
        value={value}
        mode={mode}
        onChange={onChange}
        size={size}
        errorLine={errorLine}
        isDarkMode={isDarkMode}
        className={className}
        jsSettings={jsSettings}
    />;
